export default {"src":"/_next/static/media/qr_code.96bf13ef.svg","height":206,"width":211,"blurWidth":0,"blurHeight":0};